// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__TUwYj","rotate":"Spinner_rotate__LG8GX"};